import React from 'react';
import IconBase from 'react-icon-base';

class RegionIcon extends React.Component {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <IconBase viewBox="1178.2 2879 53 53" {...this.props}>
                <path
                    // eslint-disable-next-line
                    d="M1204.7,2893.4c-6.6,0-12,5.4-12,12.1c0,6.7,5.4,12.1,12,12.1s12-5.4,12-12.1C1216.7,2898.8,1211.3,2893.4,1204.7,2893.4z M1199.6,2914.3c-3.1-1.8-5-5.2-5-8.8c0-3.6,1.9-7,5-8.8l0.8-0.5l-0.5,0.9c-1.2,2.2-1.9,5.3-1.9,8.5c0,3.2,0.7,6.2,1.9,8.5l0.5,0.9 L1199.6,2914.3z M1203.8,2915.6l-0.4-0.3c-1.7-1.1-3.4-4.6-3.4-9.8c0-5.1,1.8-8.7,3.4-9.8l0.4-0.3V2915.6z M1206.1,2915.3l-0.4,0.3 v-20.1l0.4,0.3c1.7,1.1,3.4,4.6,3.4,9.8C1209.5,2910.6,1207.7,2914.2,1206.1,2915.3z M1209.8,2914.3l-0.8,0.5l0.4-0.9 c1.2-2.2,1.9-5.3,1.9-8.5c0-3.2-0.7-6.2-1.9-8.5l-0.4-0.9l0.8,0.5c3.1,1.8,5.1,5.2,5.1,8.8C1214.9,2909.1,1213,2912.5,1209.8,2914.3 z"/>
                />
            </IconBase>
        );
    }
}

export default RegionIcon;



/** WEBPACK FOOTER **
 ** /src/shared/components/icons/Region.js
 **/